import type { ReactElement } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { DataTableProps } from '@/components/DataTable';
import type { InstalledToolListItem } from '@kirin/api-client/contracts/shadow-ai-installed-tools';
import { DataTableInstalledAiToolsContent } from './DataTableInstalledAiToolsTab';

export function InstalledToolsSection({
  organizationId,
  onUserClick,
  scopeUserId,
  tableId,
  initialState,
}: {
  organizationId: string;
  onUserClick?: (
    userId: string,
    toolId: string,
    userInfo?: { email?: string; name?: string },
    category?: string
  ) => void;
  /** KIR-3495: restrict the table to one org member (user-scope page). */
  scopeUserId?: string;
  tableId?: string;
  initialState?: DataTableProps<InstalledToolListItem>['initialState'];
}): ReactElement {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Installed AI Tools</CardTitle>
      </CardHeader>
      <CardContent>
        <DataTableInstalledAiToolsContent
          organizationId={organizationId}
          onUserClick={onUserClick}
          scopeUserId={scopeUserId}
          tableId={tableId}
          initialState={initialState}
        />
      </CardContent>
    </Card>
  );
}
